<template>
  <div class="addtocart addtocart_product">
    <div class="addtocart__inner">
      <!--<a class="product-button cart__button cart__button--black" id="productAddToCartButton" @click="cartDataAdd(), cartPopup(), cartDataOnLoad()" :data-id="productEAN">{{ buttonLabel }}</a>-->
      <div class="buyOnline -btnOnly" id="productAddToCartButton" @click="cartDataAdd(), cartPopup(), cartDataOnLoad()" :data-id="productEAN">
        <div class="popupContainer__cartIcon">
          <img src="/frontend/master/images/icons/bag.svg" alt="bag">
        </div>
        <span class="buyOnline__btn button btn__wrapper -primaryAnimated buyOnline__cart">
          {{ buttonLabel }}
        </span>
      </div>

      <!-- v-on-clickaway="away" v-bind:class="{ showPopup: showPopup }"-->
      <div class="productCart__container" id="addcartContainerOuter">
        <div class="productCart__close productCart__close--product" @click="closePopupScreen()">&#10006;</div>

        <div class="productCart__totalProduct"><span class="cartDataItemLength" id="cartDataItemLength">{{ this.cartdataitemlength }}</span><strong> {{ productLabel }}</strong> {{ inYourCartLabel }}</div>

        <div class="productCart__itemContainer" id="productCartItemContainer" v-if="this.cartdataitemlength>0">
          <vue-custom-scrollbar class="scroll-area" :settings="settings" @ps-scroll-y="scrollHanle">
            <!-- productCart__item should repeated for multiple item -->

            <div class="productCart__item" v-for="cart in this.cartData" :key="cart">
              <div class="productCart__itemImage">
                <img :src="cart.c_imageUrl" alt="productCartImage">
              </div>
              <div class="productCart__itemDetail">
                <div class="productCart__itemName">{{ cart.item_text }}</div>
                <!-- <div class="productCart__itemDescription">{{ cart.variant }}</div> -->
                <!-- <div class="productCart__itemSize">{{ cart.variant }}</div> -->
                <div class="productCart__itemDelete" @click="cartDataRemove(cart.item_id, cart.product_id);" >
                  <img src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABEAAAATCAIAAAD5x3GmAAAAGXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAAAyJpVFh0WE1MOmNvbS5hZG9iZS54bXAAAAAAADw/eHBhY2tldCBiZWdpbj0i77u/IiBpZD0iVzVNME1wQ2VoaUh6cmVTek5UY3prYzlkIj8+IDx4OnhtcG1ldGEgeG1sbnM6eD0iYWRvYmU6bnM6bWV0YS8iIHg6eG1wdGs9IkFkb2JlIFhNUCBDb3JlIDUuMy1jMDExIDY2LjE0NTY2MSwgMjAxMi8wMi8wNi0xNDo1NjoyNyAgICAgICAgIj4gPHJkZjpSREYgeG1sbnM6cmRmPSJodHRwOi8vd3d3LnczLm9yZy8xOTk5LzAyLzIyLXJkZi1zeW50YXgtbnMjIj4gPHJkZjpEZXNjcmlwdGlvbiByZGY6YWJvdXQ9IiIgeG1sbnM6eG1wPSJodHRwOi8vbnMuYWRvYmUuY29tL3hhcC8xLjAvIiB4bWxuczp4bXBNTT0iaHR0cDovL25zLmFkb2JlLmNvbS94YXAvMS4wL21tLyIgeG1sbnM6c3RSZWY9Imh0dHA6Ly9ucy5hZG9iZS5jb20veGFwLzEuMC9zVHlwZS9SZXNvdXJjZVJlZiMiIHhtcDpDcmVhdG9yVG9vbD0iQWRvYmUgUGhvdG9zaG9wIENTNiAoV2luZG93cykiIHhtcE1NOkluc3RhbmNlSUQ9InhtcC5paWQ6M0Y0NDU0RTJEN0MzMTFFQThDNENCRTgxOTYxNEM1RkYiIHhtcE1NOkRvY3VtZW50SUQ9InhtcC5kaWQ6M0Y0NDU0RTNEN0MzMTFFQThDNENCRTgxOTYxNEM1RkYiPiA8eG1wTU06RGVyaXZlZEZyb20gc3RSZWY6aW5zdGFuY2VJRD0ieG1wLmlpZDozRjQ0NTRFMEQ3QzMxMUVBOEM0Q0JFODE5NjE0QzVGRiIgc3RSZWY6ZG9jdW1lbnRJRD0ieG1wLmRpZDozRjQ0NTRFMUQ3QzMxMUVBOEM0Q0JFODE5NjE0QzVGRiIvPiA8L3JkZjpEZXNjcmlwdGlvbj4gPC9yZGY6UkRGPiA8L3g6eG1wbWV0YT4gPD94cGFja2V0IGVuZD0iciI/Ppw+BZQAAADhSURBVHjarJNLDkRAEIaZzMoKJ3AEN7C2cg5LJ3AElg7hEm5gayNcwOME5ptU4tkjRlSi8lXX/3e1pFubtpEkibYNVnYanW9uD8NgWRYi13VlpSzLKIr6vjdNc5a90zQdx1GKpmnIlEVRrEdhcxxHGLMeBAHboybP2x+DgahxfgfKEeM49jxv+h100Qi/tP9D4QnDsK5rgAxf8mRZVlUVQIYvee6c7Y7Htm0lPz2n6zolPz3HMAwln3nyPPd9HyDDlzxiOPLyFmZq23b3BNZBdynkqvKquLkn/00XjYg/AgwAhUivQxQw+sUAAAAASUVORK5CYII=" alt="productCartItemDelete">
                </div>
              </div>
              <div class="productCart__itemQtyPrice">
                <div class="productCart__itemQuantity">
                  <div class="productCart__item_ID">{{ cart.product_id }}</div>
                  <select name="quantity" class="productCart__itemQuantitySelect" @change="cartDataUpdate($event, cart.item_id);" :value="cart.quantity" :input="disableAddCart(cart.quantity, cart.product_id)">
                    <option :value="index" v-for="index in items" :key="index">{{ index }}</option>
                  </select>
                </div>
                <div class="productCart__itemPrice">$ {{ cart.price_after_order_discount }}</div>
              </div>
            </div>
          </vue-custom-scrollbar>
          <!-- Total price -->
          <div class="productCart__TotalPrice">
            <div class="productCart__TotalPriceLabel">{{ totalPriceLabel }}</div>
            <div class="productCart__TotalPriceData">$ {{ this.cartDataTotal }}</div>
          </div>
          <a class="productCart__MyBasket" @click="cartRedirect(checkouturl)">{{ myBasketLabel }}</a>
        </div>
        <div class="productCart__empty" id="productCartItemContainer" v-else>
          {{ cartEmptyMessage }}
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import vueCustomScrollbar from 'vue-custom-scrollbar';

  export default {
    name: 'addtocart',
    components: {
      vueCustomScrollbar
    },
    props: {
      buttonlabel: { type: String, default: 'Add to cart' },
      producteanid: { type: Number, required: true },
      mybasketlabel: { type: String, default: 'Checkout' },
      cartemptymessage: { type: String, default: 'Cart is empty' },
      totalpricelabel: { type: String, default: 'Total' },
      productlabel: { type: String, default: 'product' },
      inyourcartlabel: { type: String, default: 'in your cart' },
      //cartDataStatus:  { type: String, required: false, default: 'Basket' },
      maxQuantityOfProduct: { type: String, default: '5' },
      checkouturl: { type: String, required: true },
    },
    data() {
      return {
        buttonLabel: this.buttonlabel,
        productEAN: this.producteanid,
        myBasketLabel: this.mybasketlabel,
        cartEmptyMessage: this.cartemptymessage,
        totalPriceLabel: this.totalpricelabel,
        productLabel: this.productlabel,
        inYourCartLabel: this.inyourcartlabel,
        //showPopup: false,
        cartData: [],
        cartDataTotal: '',
        cartdataitemlength: 0,
        items: this.maxQuantityOfProduct,
        checkoutUrl: this.checkouturl,
        form: { key: 1 },
        disableButton: false,
        //key:this.quantity,
        settings: {
          suppressScrollY: false,
          suppressScrollX: false,
          wheelPropagation: false
        },
      };
    },
    mounted() {
      this.cartDataOnLoad();
      this.popupItem = this.$el;
      this.emptyInventory();
    },
    created () {
      window.addEventListener('scroll', this.hideOnScroll);
    },
    destroyed () {
      window.removeEventListener('scroll', this.hideOnScroll);
    },
    methods: {

      /* This function is to pass the API url */
      getData: function(url) {
        return fetch(url).then(response => response.json());
      },

      /* This function is to pass the API url --ends here */


      /* This function is to add the product to cart on click of add to cart button */
      cartDataAdd: function() {
        var productItemIdActive;
        var isColorVariantExist = document.getElementsByClassName('color-variant');
        if (isColorVariantExist.length > 0) {
          productItemIdActive = document.getElementsByClassName('productItemActiveId')[1].innerHTML;
        } else {
          productItemIdActive = document.getElementsByClassName('productItemActiveId')[0].innerHTML;
        }
        if (productItemIdActive !== '') {
          this.getData(`/api/Connector/addtocart?productid=${productItemIdActive}`)
            .then(jsonData => {
              this.cartResponseHandler(jsonData);
            });
        }
      },

      /* This function is to add the product to cart on click of add to cart button --ends here */

      /* This function is to add the product to cart on load of the page */
      cartDataOnLoad: function() {
        this.getData(`/api/connector/getcart`)
          .then(jsonData => {
            this.cartResponseHandler(jsonData);
          });
      },

      /* This function is to add the product to cart on load of the page --ends here*/

      /* This function is to update the product to cart on change of quantity */
      cartDataUpdate: function(event, cartItemID) {
        this.getData(`/api/connector/alterquantity?itemId=${cartItemID}&quantity=${event.target.value}`)
          .then(jsonData => {
            this.cartResponseHandler(jsonData);
          });
      },

      /* This function is to update the product to cart on change of quantity --ends here*/

      /* This function is to remove the product to cart on click of delete icon */
      cartDataRemove: function(cartItemID, productID) {
        this.getData(`/api/connector/RemoveProduct?itemId=${cartItemID}`)
          .then(jsonData => {
            this.cartResponseHandler(jsonData);
          });
        var productItemIdExists = document.getElementsByClassName('productItemActiveId')[0];
        if (undefined !== productItemIdExists) {
          var isColorVariantExist = document.getElementsByClassName('color-variant');
          var productItemId;
          if (isColorVariantExist.length > 0) {
            productItemId = document.getElementsByClassName('productItemActiveId')[1].innerHTML;
          } else {
            productItemId = document.getElementsByClassName('productItemActiveId')[0].innerHTML;
          }
          if (productItemId === productID) {
            document.getElementById('addtocartComponent').classList.remove('disabledComponent');
          }
        }
      },

      /* This function is to add the product to cart on click of delete icon --ends here */

      /* This function is to redirect on checkout click */
      cartRedirect: function (urlCheckout) {
        fetch(`/api/connector/checkout`).then(function(response) {
          if (response.status === 200) {
            window.location = urlCheckout;
          }
        });
      },

      /* This function is to redirect on checkout click --ends here */

      /* This function is to check empty inventory on page load */
      emptyInventory: function () {
        const addtoCartLoader = document.getElementById('addtocartComponentLoader');
        if (addtoCartLoader) {
          addtoCartLoader.classList.add('active');
        }
        setTimeout(() => {
          var emptyProductItemIdActive;
          var productItemIdExists = document.getElementsByClassName('productItemActiveId')[0];
          if (undefined !== productItemIdExists) {
            var emptyisColorVariantExist = document.getElementsByClassName('color-variant');
            if (emptyisColorVariantExist.length > 0) {
              emptyProductItemIdActive = document.getElementsByClassName('productItemActiveId')[1].innerHTML;
            } else {
              emptyProductItemIdActive = document.getElementsByClassName('productItemActiveId')[0].innerHTML;
            }
            this.getData(`/api/connector/productexistsininventory?productid=${emptyProductItemIdActive}`)
              .then(jsonData => {
                if (!(jsonData.orderable)) {
                  document.getElementById('addtocartComponent').classList.add('disabledComponent');
                } else {
                  var addtocartComponentData = document.getElementById('addtocartComponent');
                  var priceContent = document.getElementById('sfccPrice');
                  if (priceContent.innerHTML  !== '') {
                    addtocartComponentData.classList.remove('disabledComponent');
                    this.isMaxInventory();
                  } else {
                    addtocartComponentData.classList.add('disabledComponent');
                  }
                }
                document.getElementById('addtocartComponentLoader').classList.remove('active');
              });
          }
        },400);
      },

      /* This function is to check empty inventory on page load --ends here */

      /* This function is to check max inventory on variant change */
      isMaxInventory: function () {
        var emptyProductItemIdActive;
        var emptyisColorVariantExist = document.getElementsByClassName('color-variant');
        if (emptyisColorVariantExist.length > 0) {
          emptyProductItemIdActive = document.getElementsByClassName('productItemActiveId')[1].innerHTML;
        } else {
          emptyProductItemIdActive = document.getElementsByClassName('productItemActiveId')[0].innerHTML;
        }
        var ProductItemID = document.getElementsByClassName('productCart__item_ID');
        for (var i = 0; i < ProductItemID.length; i++) {
          var activeData = ProductItemID[i].textContent;
          if (emptyProductItemIdActive === activeData) {
            var theSelectData = document.getElementsByClassName('productCart__itemQuantitySelect')[i];
            var lastValue = theSelectData.options[theSelectData.options.length - 1].value;
            var selectedText = theSelectData.options[theSelectData.selectedIndex].value;
            if (selectedText >= lastValue) {
              document.getElementById('addtocartComponent').classList.add('disabledComponent');
            } else {
              document.getElementById('addtocartComponent').classList.remove('disabledComponent');
            }
          }
        }
      },

      /* This function is to check max inventory on variant change --ends here */

      /* This function is to json response return */
      cartResponseHandler: function(jsonData) {
        //this.cartDataStatus = jsonData._type;
        this.cartData = jsonData.product_items;
        this.cartDataTotal = jsonData.product_total;
        this.cartItemLength();
      },

      /* This function is to json response return --ends here*/

      disableAddCart: function(cartQuantity, productID) {
        if (this.items === '') {
          this.items = 5;
        }
        this.items = parseInt(this.items);
        var productItemIdExists = document.getElementsByClassName('productItemActiveId')[0];
        if (undefined !== productItemIdExists) {
          var isColorVariantExist = document.getElementsByClassName('color-variant');
          var productItemId;
          if (isColorVariantExist.length > 0) {
            productItemId = document.getElementsByClassName('productItemActiveId')[1].innerHTML;
          } else {
            productItemId = document.getElementsByClassName('productItemActiveId')[0].innerHTML;
          }
          if (productItemId === productID) {
            if (cartQuantity >= this.items) {
              document.getElementById('addtocartComponent').classList.add('disabledComponent');
            } else {
              document.getElementById('addtocartComponent').classList.remove('disabledComponent');
            }
          }
        }
      },

      /* This function is to show the mini cart on click of add to cart button or on click of cart icon in header nav */
      cartPopup: function() {
        //this.showPopup = true;
        document.body.classList.add('showPopupCart');
      },

      /* This function is to show the mini cart on click of add to cart button or on click of cart icon in header nav --ends here*/

      /* This function is to hide the mini cart on click of close icon */
      closePopupScreen: function() {
        //this.showPopup = false;
        document.body.classList.remove('showPopupCart');
      },

      /* This function is to hide the mini cart on click of close icon --ends here*/

      /* This function is to count the number of items in the cart */
      cartItemLength: function() {
        var productcartcount = document.getElementById('productCartCount');
        if (this.cartData) {
          productcartcount.innerHTML = this.cartData.length;
          this.cartdataitemlength = this.cartData.length;
        } else {
          productcartcount.innerHTML = 0;
          this.cartdataitemlength = 0;
        }
      },

      /* This function is to count the number of items in the cart --ends here*/

      scrollHanle() {
      },

      hideOnScroll() {
        if (document.body.scrollTop > 50 || document.documentElement.scrollTop > 50) {
          document.body.classList.remove('showPopupCart');
        }
      }
    }
  };
</script>


<style lang="scss" src="./addtocart.scss"></style>
<!-- <style lang="scss" src="./perfect-scrollbar.scss"></style> -->
